import * as citation from './Citation';
import * as bibTex from './BibTex';

export default { citation, bibTex };
